import { fabric } from 'fabric';

const MIN_CONTROL_SIZE = 8;
const MAX_CONTROL_SIZE = 20;
const ANIMATION_DURATION = 125;

export interface AnimationCallbacks {
  onRequestRender?: () => void;
  onComplete?: () => void;
}

export class ShapeConnectControlAnimator {
  isAnimating = false;
  currentSize: number = MIN_CONTROL_SIZE;

  get atMaxSize(): boolean {
    return this.currentSize === MAX_CONTROL_SIZE;
  }

  setMaxSize() {
    this.currentSize = MAX_CONTROL_SIZE;
  }

  animate(state: 'enter' | 'exit', callbacks: AnimationCallbacks = {}): void {
    if (this.isAnimating) {
      this.isAnimating = false;
    }

    let duration = 0;
    const startValue = this.currentSize;
    let endValue = this.currentSize;

    switch (state) {
      case 'enter':
        endValue = MAX_CONTROL_SIZE;
        duration = ANIMATION_DURATION * (MIN_CONTROL_SIZE / this.currentSize);
        break;
      case 'exit':
        duration = ANIMATION_DURATION * (this.currentSize / MAX_CONTROL_SIZE);
        endValue = MIN_CONTROL_SIZE;
        break;
      default:
        return;
    }

    fabric.util.animate({
      startValue,
      endValue,
      duration,
      onStart: () => {
        this.isAnimating = true;
      },
      onChange: (newSize: number) => {
        this.currentSize = newSize;
        callbacks.onRequestRender?.();
      },
      onComplete: () => {
        this.isAnimating = false;
        callbacks.onComplete?.();
      },
      abort: () => !this.isAnimating,
    });
  }

  stopAnimation(): void {
    this.isAnimating = false;
    this.currentSize = MIN_CONTROL_SIZE;
  }
}
